import styled, { css } from 'styled-components';

const backgroundGreen =
  'linear-gradient(249deg, rgba(0, 179, 9, 0.00) 3.64%, rgba(0, 179, 9, 0.04) 9.2%, rgba(0, 179, 9, 0.13) 33.31%, rgba(0, 179, 9, 0.18) 61.13%, rgba(0, 179, 9, 0.20) 96.36%);';
const backgroundRed =
  ' linear-gradient(249deg, rgba(255, 0, 7, 0.00) 3.64%, rgba(255, 0, 7, 0.09) 20.33%, rgba(255, 0, 7, 0.15) 41.65%, rgba(255, 0, 7, 0.19) 65.76%, rgba(255, 0, 7, 0.20) 96.36%)';

export const Container = styled.section`
  display: ${({ $show }) => ($show ? 'flex' : 'none')};
  flex-direction: column;
  gap: 48px;
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 60px;

  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const Collumn = styled.div`
  width: 100%;
  max-width: ${({ $max }) => ($max ? `${$max}px` : '100%')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({ $gap }) => ($gap ? `0px` : '44px')};

  @media ${({ theme }) => theme.devices.mobile} {
    max-width: 100%;

    h1 {
      font-size: 44px;
      line-height: 44px;
    }
  }

  a {
    width: 100%;

    &:hover {
      transition: 0.7s;
      opacity: 0.8;
    }

    img {
      width: 100%;
    }
  }
`;

export const InfoVerif = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 8px;
  border: 1px solid ${({ $diff }) => ($diff ? '#FF0007' : '#00B309')};
  background: ${({ $diff }) => ($diff ? backgroundRed : backgroundGreen)};
  padding: 16px;
  border-radius: 28px;

  > div {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  p {
    font-size: 16px;
    font-weight: 400;
    margin-bottom: -2px;
  }

  span {
    font-size: 14px;
  }
`;

export const GroupCam = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 32px;
  background-color: transparent;
  padding: 16px 28px;

  .custom-midia {
    max-width: 100%;
    height: 560px;
  }

  button {
    width: 50%;
    color: ${({ theme }) => theme.colors.grey.white};
  }
`;

export const TopCam = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;

  img {
    width: 100%;
  }

  .no {
    max-width: 20px;
    margin-top: -2px;
  }

  .yes {
    max-width: 26px;
  }
`;

export const LinkCam = styled.button`
  width: 100%;
  height: 160px;
  background-color: transparent;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;
  background-image: url(${({ $cam }) => $cam});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  border: 0;

  &:hover {
    transition: 0.7s;
    opacity: 0.8;
  }

  div {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    color: ${({ theme }) => theme.colors.grey.white};

    span {
      width: fit-content;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 6px 16px;
      border-radius: 16px;
      background-color: ${({ theme }) => theme.colors.grey[500]};
      border: 1px solid ${({ theme }) => theme.colors.grey.white};
    }
  }

  img {
    position: absolute;
    right: 0;
  }
`;

export const WrapImg = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 100%;
    object-fit: cover;
  }

  .banner {
    width: 100%;
    height: 320px;
    border-radius: 0 0 64px 0;
  }

  .profile {
    position: relative;
    top: -80px;
    margin-bottom: -60px;
    max-width: 100px;
    height: 100px;
    border-radius: 100%;
  }

  .link {
    width: 100% !important;
    color: ${({ theme }) => theme.colors.grey.white};
  }
`;

export const LinkUpload = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  a {
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 16px 32px;
    border-radius: 8px;
    border: 2px dashed ${({ theme }) => theme.colors.grey.white};

    &:hover {
      transition: 0.7s;
      opacity: 0.8;
      background-color: rgba(256, 256, 256, 0.1);
    }

    p {
      margin-bottom: -6px;
    }

    img {
      width: 100%;
      max-width: 32px;
    }
  }
`;

export const GroupButton = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
  gap: 20px;

  @media ${({ theme }) => theme.devices.mobile} {
    margin-top: 18px;
    margin-bottom: 12px;
  }

  button {
    display: flex;
    align-items: center;
    border-radius: 20px;
    padding: 8px 24px;
    background-color: transparent;
    border: 1px solid ${({ theme }) => theme.colors.grey.white};
    color: ${({ theme }) => theme.colors.grey.white};

    ${({ $selected }) =>
      $selected === 'photo' &&
      css`
        &:nth-child(1) {
          background-color: rgba(256, 256, 256, 0.4);
        }
      `}

    ${({ $selected }) =>
      $selected === 'video' &&
      css`
        &:nth-child(2) {
          background-color: rgba(256, 256, 256, 0.4);
        }
      `}

    span {
      @media ${({ theme }) => theme.devices.mobile} {
        font-size: 14px;
      }
    }

    &:hover {
      transition: 0.7s;
      background-color: rgba(256, 256, 256, 0.4);
    }
  }
`;

export const GroupUpload = styled.div`
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 20px auto 0 auto;

  @media ${({ theme }) => theme.devices.mobile} {
    margin: 0 auto;
  }

  > div {
    flex: 0 1 calc(33.333% - 8px);
    max-width: calc(33.333% - 8px);
    border-radius: 36px;

    @media ${({ theme }) => theme.devices.mobile} {
      border-radius: 20px;
      height: 140px;
    }
  }
`;

// Adicione estes estilos ao seu arquivo styles.js existente

export const LoadMoreContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;
  width: 100%;
`;

export const LoadMoreButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
  min-width: 140px;
  min-height: 45px;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
    background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }
`;
